export default {
  people: [
    {
      name: 'Tim Chen',
      firstName: 'Tim',
      title: 'Chief Executive Officer',
      blurb:
        'Tim started NerdWallet after realizing there is a lack of trustworthy financial advice available to consumers.',
      description:
        "In 2009, Tim and co-founder Jake Gibson started NerdWallet with a goal to bring clarity to all of life's financial decisions. Since then, he's been busy as CEO of NerdWallet, helping inspire our Nerds to bring clarity to personal finance.\n\n\"NerdWallet is on a mission shared by a dedicated group of Nerds. The idea of a world where everyone is empowered to make financial decisions with confidence transcends any individual, permeating the entire organization's values.\"",
      image: '/images/executives/tim_lg.jpg',
      imageMobile: '/images/executives/tim_sm.jpg',
      imageAlt: 'Tim Chen',
      linkedInLink: 'https://www.linkedin.com/in/tim-chen-1722b9/',
    },
    {
      name: 'Lauren StClair',
      firstName: 'Lauren',
      title: 'Chief Financial Officer',
      blurb:
        "With over 18 years of experience in finance, Lauren leads NerdWallet's financial operations with a focus on expanding domestic and international growth.",
      description:
        'Lauren brings 18+ years of finance experience for both startups and multinational corporations. Prior to joining NerdWallet, she was the CFO of North America at eBay, and CFO at StubHub International in Spain. Lauren has a B.S. degree from Stanford University and an M.B.A. from Duke University.\n\n"I am constantly amazed at the discipline we have instilled across the NerdWallet organization. We are thoughtful about our investments yet comfortable taking informed risks to push the boundaries and deliver the best for our customers."',
      image: '/images/executives/lauren_lg.jpg',
      imageMobile: '/images/executives/lauren_sm.jpg',
      imageAlt: 'Lauren StClair',
      linkedInLink: 'https://www.linkedin.com/in/lauren-stclair-waugh-a305ab8/',
    },
    {
      name: 'Kevin Yuann',
      firstName: 'Kevin',
      title: 'Chief Business Officer',
      blurb:
        'Kevin focuses on driving growth in our businesses. He leads our General Managers, Business Development, BizOps, and Corporate Development teams.',
      description:
        'Before joining NerdWallet, Kevin managed strategy and operations teams at Visa and Deloitte Consulting. He has an M.B.A. from UCLA and a B.A. from Brown University.\n\n"Winning together as a team is more fulfilling than doing it alone."',
      image: '/images/executives/kevin_lg.jpg',
      imageMobile: '/images/executives/kevin_sm.jpg',
      imageAlt: 'Kevin Yuann',
      linkedInLink: 'https://www.linkedin.com/in/kevinyuann/',
    },
    {
      name: 'Jason Rodriguez',
      firstName: 'Jason',
      title: 'Chief Product Officer',
      blurb:
        'Jason Rodriguez has spent more than 20 years leading product, engineering and design teams with a focus on delivering engaging, personalized user experiences.',
      description:
        'Prior to joining NerdWallet, Jason led product engineering and design teams at Fundera (acquired by NerdWallet in 2020), SoulCycle, Condé Nast and News Corp. He has a B.S. in Computer Science from NYU School of Engineering.\n\n"Our product and tools are core to the unique, personalized user experience we deliver, and I\'m proud to help bring that product to life for our consumers and SMBs."',
      image: '/images/executives/jason_lg.jpg',
      imageMobile: '/images/executives/jason_sm.jpg',
      imageAlt: 'Jason Rodriguez',
      linkedInLink: 'https://www.linkedin.com/in/jayrod/',
    },
    {
      name: 'Ekumene "E" Lysonge',
      firstName: '"E"',
      title: 'Chief Legal Officer and Corporate Secretary',
      blurb:
        'E joins NerdWallet with 20+ years of experience leading legal functions in the gaming, entertainment, eCommerce, technology, and real estate sectors.',
      description:
        'E\'s experience as a corporate generalist spans multiple subject matters, including, but not limited to, corporate governance, securities, data privacy, technology and intellectual property, regulatory and government affairs, mergers and acquisitions, real estate, and property management.\n\n"At NerdWallet, we always aim to lead from the front, whether by utilizing our cutting-edge data analytics, research, and content publishing platforms, or using our voice to encourage private industry to take a stand socially and invest dollars in the communities most in need."',
      image: '/images/executives/e_lg.jpg',
      imageMobile: '/images/executives/e_sm.jpg',
      imageAlt: 'Ekumene Lysonge',
      linkedInLink: 'https://www.linkedin.com/in/ekumenelysonge',
    },
    {
      name: 'Lynee Luque',
      firstName: 'Lynee',
      title: 'Chief People Officer',
      blurb:
        'Lynee enjoys scaling culture within organizations and creating end-to-end employee programs that support growth and change.',
      description:
        'Lynee brings 20+ years of professional experience, 15 as an HR professional and 6 in Advisory Services. This blend of experience ensures we not only build people and cultural programs that scale but also sets us up to support business growth. Prior to joining NerdWallet, Lynee was VP and Head of People at Envoy and Global Human Resources Director for Twitter. Lynee has a B.S. degree from UC Berkeley and an M.B.A. from University of Michigan, Ann Arbor.\n\n"We\'re building an organization where every Nerd has an opportunity to grow personally and professionally."',
      image: '/images/executives/lynee_lg.jpg',
      imageMobile: '/images/executives/lynee_sm.jpg',
      imageAlt: 'Lynee Luque',
      linkedInLink: 'https://www.linkedin.com/in/lynee-luque-b739541/',
    },
    {
      name: 'Sam Yount',
      firstName: 'Sam',
      title: 'VP, Consumer Credit',
      blurb:
        'Sam Yount is a data-driven leader with more than 20 years of fintech experience.',
      description:
        'Prior to NerdWallet, he was the CEO of On the Barrelhead (acquired by NerdWallet in 2022), CMO at LendingTree, and was VP of Marketing at Aptible, FutureAdvisor and Personal Capital. Sam has a B.A. in Sociology from the University of Chicago.\n\n"Each consumer has different needs – there is no one-size-fits-all. We aim to help them make sense of available options and provide trusted guidance no matter where they are in their financial journey."',
      image: '/images/executives/sam_lg.jpg',
      imageMobile: '/images/executives/sam_sm.jpg',
      imageAlt: 'Sam Yount',
      linkedInLink: 'https://www.linkedin.com/in/samuelyount/',
    },
    {
      name: 'Hanah Cho',
      firstName: 'Hanah',
      title: 'VP, Content',
      blurb:
        'Hanah is an award-winning financial journalist who helps NerdWallet create content that makes complex financial decisions easier to understand so consumers can lead richer lives.',
      description:
        'Hanah started her career in journalism almost 20 years ago and has worked as a writer for The Associated Press, The Los Angeles Times, The Baltimore Sun, and The Dallas Morning News. Her specialties include mutual funds, energy issues, small businesses, entrepreneurs, and workplace trends. She has a B.A. in English and Political Science from Rutgers University and a Masters in Journalism from the University of Maryland.\n\n"NerdWallet cultivates a rare combination of collaborative and open, candid, and constructive culture that allows Nerds to develop and thrive as leaders."',
      image: '/images/executives/hanah_lg.jpg',
      imageMobile: '/images/executives/hanah_sm.jpg',
      imageAlt: 'Hanah Cho',
      linkedInLink: 'https://www.linkedin.com/in/hanahcho',
    },
    {
      name: 'Keely Spillane',
      firstName: 'Keely',
      title: 'VP, Communications & Organic Growth',
      blurb:
        'Keely Spillane leads NerdWallet’s global integrated communications, corporate impact and organic growth strategies.',
      description:
        "Under Keely's leadership, NerdWallet has elevated the company's global reputation as a trusted provider of financial guidance, built confidence in its business and strategy internally, and established itself as a socially responsible business by launching and formalizing its ESG commitments and CSR initiative. Keely holds a B.A. in Communications and Political Science from U.C. Davis.\n\n\"By leveraging strategic communications and organic growth practices, we're building NerdWallet's reputation and establishing ourselves as the trusted financial platform consumers can turn and return to for all their money questions.\"",
      image: '/images/executives/keely_lg.jpg',
      imageMobile: '/images/executives/keely_sm.jpg',
      imageAlt: 'Keely Spillane',
      linkedInLink: 'https://www.linkedin.com/in/keely-spillane-75883b16/',
    },
    {
      name: 'Alison McCoy',
      firstName: 'Alison',
      title: 'VP, Brand Marketing',
      blurb:
        "Alison McCoy has reshaped NerdWallet's brand from a fintech startup to a public company with a trusted household name.",
      description:
        'With over 15 years of experience leading marketing and branding initiatives, Alison builds brands that add distinct value to consumer\'s lives and drive outsized business results. Alison has a B.A. in Public Relations from the University of Southern California.\n\n"NerdWallet is a name consumers know they can rely on, and through marketing campaigns that meet consumers where they are, I\'m proud to say we have built one of the fastest growing and most trusted brands in the personal finance category."',
      image: '/images/executives/alison_lg.jpg',
      imageMobile: '/images/executives/alison_sm.jpg',
      imageAlt: 'Alison McCoy',
      linkedInLink: 'https://www.linkedin.com/in/alison-mccoy-01054b4/',
    },
  ],
};
